export default __webpack_public_path__ + "static/media/footer_bg.d02e27e3.svg";